import { Component, OnInit } from '@angular/core';

import { BrowserService } from './browser.service';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public vertical: any = false;

  numImagesToLoad = 1;

  imgLoadedCount = 0;

  noWebp = false;

  hasLoaded = false;

  constructor(private browserService:BrowserService) { }


  ngOnInit() {
    this.browserService.addLoadListener(() => {
      this.noWebp = !this.browserService.supportsWebp();
    });

    this.imgLoadedCount = 0;

    const execute = () => {
      this.vertical = window.innerHeight > window.innerWidth;
    };

    window.addEventListener('resize', () => {
      execute();
    });

    execute();

  }

  countLoadedImage = (event:any) => {
    console.log('image loaded', event);
    this.imgLoadedCount ++;
    if(this.imgLoadedCount >= this.numImagesToLoad) {
      this.hasLoaded = true;
    }
  }


}
